
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{staticInfo.Titulo}}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-120 gx-5 gx-lg-0 pontosVendaPage">
      <div class="row justify-content-center mb-4 pontosVendaFiltersBlock">
        <div class="col-lg-11 col-12 p-3 bg-secondary bdr-r-10">
          <form [formGroup]="searchForm" *ngIf="searchForm">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label aria-label="Município" class="mb-1 color-white">{{'formLabels.municipio' | translate}}</label>
                <select aria-label="Selecionar Município" formControlName="municipality" class="form-select">
                  <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option *ngFor="let municipality of municipalities"
                          value="{{municipality.code}}">{{ municipality.name }}
                  </option>
                </select>
              </div>
              <div class="col-lg col-12 align-content-end mt-3 mt-lg-0">
                <div class="search-container">
                  <input type="text" formControlName="text" class="form-control search-input" placeholder="{{'formPlaceholders.pesquisa' | translate}}">
                  <i class="uil uil-search fs-20px search-icon"></i>
                </div>
              </div>
              <div class="col-lg-auto col-12 align-content-end text-end mt-3 mt-lg-0">
                <button title="Limpar Formulário" (click)="onReset()" type="button" class="btn btn-link-white" [disabled]="!isFormValid()"><p class="m-0 fw-600">{{'buttons.limpar' | translate}}<i class="uil uil-backspace fs-20px ms-2 color-white"></i></p></button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-11 bg-white bdr-r-10">
          <div class="row p-4">
            <div class="col-lg-6 col-12 p-0 map-wrapper">

              <div [hidden]="true" class="map-switcher">
                <button
                  (click)="changeStyle('streets')"
                  [class.active]="currentStyle === 'streets'">
                  {{'common.map' | translate}}
                </button>
                <button
                  (click)="changeStyle('satellite')"
                  [class.active]="currentStyle === 'satellite'">
                  {{'common.satellite' | translate}}
                </button>
              </div>

              <mgl-map
                [style.height]="'500px'"
                [style.width]="'100%'"
                [style]="mapStyle"
                [zoom]="[zoom]"
                [minZoom]="8"
                [center]="[center.lng, center.lat]"
                [fitBounds]="bounds"
                [fitBoundsOptions]="{ padding: 50 }"
                (mapLoad)="onMapLoad($event)"
                [attributionControl]="false">

                <mgl-marker
                  *ngFor="let marker of salePointsFiltered; let i = index"
                  [lngLat]="[marker.position.lng, marker.position.lat]"
                  [anchor]="'bottom'">

                  <div
                    class="marker-wrapper"
                    (click)="selectEstablishment(marker, i); $event.stopPropagation()"
                    [style.width]="getSalePointStyle(marker, i).width"
                    [style.height]="getSalePointStyle(marker, i).height">

                    <img
                      [src]="getSalePointStyle(marker, i).src"
                      class="marker-image">
                  </div>

                </mgl-marker>

                <mgl-popup
                  *ngIf="selectedSalePoint"
                  [lngLat]="[selectedSalePoint.position.lng, selectedSalePoint.position.lat]"
                  [closeOnClick]="false"
                  [anchor]="'bottom'"
                  [offset]="[0, -50]"
                  (close)="resetMap()">

                  <div class="d-block text-center p-infoWindow">
                    <p class="fs-12px fw-700">{{ selectedSalePoint?.municipality }}</p>
                    <p *ngIf="selectedSalePoint?.name != ''" class="m-0 fw-800">{{ selectedSalePoint?.name }}</p>
                    <p class="stops-name fs-12px">{{ selectedSalePoint?.address }}</p>
                    <p class="m-0 fs-10px">{{'pontosVenda.contacto' | translate}}:&nbsp;{{ selectedSalePoint?.contact }}</p>
                    <p class="m-0 fs-10px">{{'pontosVenda.horario' | translate}}:&nbsp;{{ selectedSalePoint?.hours }}</p>
                  </div>

                </mgl-popup>

              </mgl-map>
            </div>
            <div class="col-lg col-12 ms-lg-4 ms-0 p-3 bg-white overflow-y-auto h500" (click)="resetMap()">
              <ul class="list-unstyled d-grid mb-0">
                <li class="bg-stops-list p-2 mb-2 d-inline-flex justify-content-between"
                    *ngFor="let stop of salePointsFiltered, let i = index;"
                    (click)="selectEstablishment(stop, i); $event.stopPropagation()"
                    [ngClass]="{'active-stop-sales': selectedSalePoint?.id === stop.id, 'inactive-stop': selectedSalePoint?.id !== stop.id}">
                  <div>
                    <p class="stops-municipio">{{ stop.municipality }}</p>
                    <p *ngIf="stop.name != ''" class="m-0 fw-800">{{ stop.name }}</p>
                    <p class="stops-nameSalesPoint fs-12px">{{ stop.address }}</p>
                    <p class="stops-nameSalesPoint fs-12px">{{'pontosVenda.contacto' | translate}}:&nbsp;{{ stop.contact }}</p>
                    <p class="stops-nameSalesPoint fs-12px">{{'pontosVenda.horario' | translate}}:&nbsp;{{ stop.hours }}</p>
                    <!--<span class="badge rounded-pill" [ngClass]="{'text-bg-success': stop.open, 'text-bg-danger': !stop.open}">{{ stop.open ? staticInfo.Aberto : staticInfo.Fechado }}</span>-->
                  </div>
                  <div class="align-self-center">
                    <p class="bold fs-12px m-0">{{staticInfo.Ver_Mapa}}<i class="uil uil-arrow-up-right fs-20px ms-2"></i></p>
                  </div>
                </li>
              </ul>
              <div *ngIf="salePointsFiltered.length == 0" class="noResultsText">{{staticInfo.Sem_Pontos_Venda}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

